module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-2-a6ecdbaaf952c7ea6eb63f73b0ffd5bb.jpg";